<template>
  <div class="service-terminate">
    <modal name="terminateServiceModal1" :adaptive="true" :width="500" height="auto"
           class="modal-style">
      <div class="lp-modal-wrapper">
        <div class="flex-end">
          <div class="material-icons unselect" @click="$modal.hide('terminateServiceModal1')">close</div>
        </div>
        <div class="t-content">
          <template v-if="step===1">
            <div>
              <div class="t-title">서비스를 해지하시겠습니까?</div>
              <div class="t-subtitle">서비스 해지 전, 아래 정보를 확인해주세요.</div>
            </div>
            <ul class="t-body">
              <!-- 서비스 정책에 따라서 주석처리(2022.07.18) -->
              <!--<li>취소 수수료 10%가 적용되며,  정가로 일할 계산(30일기준) 되어 정산됩니다.</li>-->
              <li>건결제 서비스는 환불이 불가합니다.</li>
              <li>해지된 서비스는 재개설이 불가합니다.</li>
              <li>부가서비스는 직접 계약 종료를  진행해주셔야 합니다.<br>
                계약 종료와 관련된 사항은 1:1 문의를 통해 문의해주시기 바랍니다.</li>
            </ul>
            <div class="t-button-group">
              <button class="button is-primary" @click="routerPush(getPath('launchpack/inquiry/customer/create'))">1:1문의</button>
              <button class="button is-sub4" @click="clickStep">다음</button>
            </div>
          </template>
          <template v-if="step===2">
            <div class="t-title">해지하시는 이유가 무엇인가요?</div>
            <div v-for="(r, r_idx) in reasonArr" :key="`r-${r_idx}`">
              <div class="flex-align unselect" style="margin-bottom:5px"
                   @click="selectReason(r)">
                <div
                  :class="{'circle-selected': r.label===value.terminate_reason, 'circle': r.label!==value.terminate_reason}"></div>
                <div style="margin-left:8px">{{ r.label }}</div>
              </div>

              <div v-if="value.terminate_reason==='개발 예산 초과' && r.label==='개발 예산 초과'">
                <div class="flex-align">
                  <input class="input product-short-input"
                         style="font-size:11px;text-align:left"
                         v-model="value.terminate_reason_detail"
                         placeholder="희망하시는 플랫폼 개발 예산을 입력해주세요."
                         @input="setPrice"
                         type="number">
                  <span class="size-11 sub3" style="width:26px;margin-left:4px">만원</span>
                </div>
              </div>
              <div v-else-if="value.terminate_reason==='기타' && r.label==='기타'">
                <input class="input product-short-input"
                       style="font-size:11px"
                       v-model="value.terminate_reason_detail"
                       placeholder="해지 이유를 입력해주세요."
                       type="text">
              </div>
            </div>
            <div class="t-button-group">
              <button class="button is-primary" @click="hideTerminateServiceModal">해지 안 함</button>
              <button class="button is-sub4" @click="clickStep">다음</button>
            </div>
          </template>
          <template v-if="step===3">
            <div class="t-title">서비스 플랜을 변경하거나 일시정지하는데<br>도움이 필요하세요?</div>
            <div class="t-subtitle">런치팩은 고객님의 요구 조건에 맞는 플랜을 찾을 수 있도록 도와드립니다.</div>
            <div class="t-body">
              서비스를 완전히 해지하지 않고<br>
              호스팅비 납부만으로  관리자 페이지만 일시정지 할 수도 있습니다.<br><br>
              아래 1:1 문의를 통해 플랜 변경과 일시정지에 대해 문의해보세요 :)
            </div>
            <div class="t-button-group">
              <button class="button is-primary"
                      @click="routerPush(getPath('launchpack/inquiry/customer/create'))">1:1문의
              </button>
              <button class="button is-sub4" @click="openTerminateServiceModal2">다음</button>
            </div>
          </template>
          <template v-if="step===4">
            <div class="t-title">서비스 해지 신청이 완료되었습니다.</div>
            <div class="t-subtitle">그동안 런치팩 솔루션을 이용해주셔서 감사합니다.</div>
            <div class="flex-center">
              <div class="t-body">
                <div class="text-center" style="margin:8px 0">[서비스 해지 정보]</div>
                <div class="t-grid">
                  <div>·서비스명</div>
                  <div>{{ service.service_name }}</div>
                </div>
                <div class="t-grid">
                  <div>·서비스 해지 신청일</div>
                  <div>{{ serviceTerminateReqDate }}</div>
                </div>
                <div class="t-grid">
                  <div>·서비스 해지 예정일</div>
                  <div>{{ datesFormat(service.terminate_expect_date, 'date_4') }}</div>
                </div>
              </div>
            </div>
            <div class="t-button-group">
              <button class="button is-primary" @click="$modal.hide('terminateServiceModal1')">확인</button>
            </div>
          </template>
        </div>
      </div>
    </modal>

    <div class="terminate-2">
      <sweet-modal overlay-theme="dark" ref="terminateServiceModal2" width="600px">
        <div class="t-title">서비스 이용 플랜 수정</div>
        <div class="t-subtitle" style="margin-bottom:16px">지금 해지하더라도
          <span class="primary">{{ datesFormat(service.plan.use_end_date, 'date_3') }}</span>
          까지 서비스를 계속 이용할 수 있습니다.</div>
        <div class="t-body">
        <div class="weight-600" style="margin-bottom:12px">해지 완료되면 제작하신 서비스 상태를 어떻게 할까요?</div>
          <lp-radio :val.sync="selectedServiceStatus"
                    value_name="value"
                    label_name="label"
                    :block="true"
                    :data="stopArr"></lp-radio>
        </div>
        <div class="box-shutdown flex-between">
          <div style="white-space:pre-line;color:#FF5722">{{ selectedServiceStatusText }}</div>
          <button class="button is-primary button-shutdown" @click="openTerminateServiceModal3">정산 및 해지하기</button>
        </div>
      </sweet-modal>
      <sweet-modal overlay-theme="dark" ref="terminateServiceModal3" width="900px">
        <market-terminate-modal :service="service"
                                :selectedServiceStatus="selectedServiceStatus"
                                @stop="saveData"></market-terminate-modal>
      </sweet-modal>
    </div>
  </div>
</template>
<script>
  import { SweetModal } from 'sweet-modal-vue';
  import moment from 'moment'
  import MarketTerminateModal from "./MarketTerminateModal";
  import LpRadio from "../../../module/common/LpRadio";
  export default {
    name: "ServiceTerminate",
    props: {
      service: {
        type: Object
      }
    },
    components: {LpRadio, MarketTerminateModal, SweetModal},
    created() {
    },
    data() {
      return {
        selectedServiceStatus: 10,
        stopArr: [
          { label: '관리자 솔루션으로 운영하지는 않지만, 고객들이 방문할 수 있게 서비스는 유지', value: 10 },
          { label: '관리자 솔루션과 서비스 모두 운영하지 않고 휴면 전환 저장', value: 99 },
          { label: '서비스 삭제', value: 100 }
        ],
        value: {
          terminate_reason: '런치팩 솔루션 기능 불만족',
          terminate_reason_detail: ''
        },
        reasonArr: [
          {label: '런치팩 솔루션 기능 불만족', value: '런치팩 솔루션 기능 불만족'},
          {label: '이용이 어려움', value: '이용이 어려움'},
          {label: '잦은 버그 발생', value: '잦은 버그 발생'},
          {label: '비용이 너무 높음', value: '비용이 너무 높음'},
          {label: '비즈니스 중단 예정', value: '비즈니스 중단 예정'},
          {label: '기타', value: '기타'}
        ],
        step: 1
      }
    },
    computed: {
      selectedServiceStatusText() {
        return {
          10: '월 5만원의 호스팅 비용만 정기결제되며, 고객이 사이트에 방문할 수 있습니다.\n언제든 재운영을 할 수 있습니다.\n' +
              '서비스 상태를 이후에도 변경할 수 있습니다.',
          99: '월 2만 5천원의 호스팅 비용만 결제되며, 고객 사이트가 셧다운 되어 있어도\n휴면 상태로 언제든 재 운영을 할 수 있습니다.\n' +
              '서비스 상태를 이후에도 변경할 수 있습니다.',
          100: '제작한 서버 설정 내용과 DB가 전부 삭제되며, 복구할 수 없습니다.'
        }[this.selectedServiceStatus];
      },
      serviceTerminateReqDate() {
        return moment().format('YYYY-MM-DD')
      }
    },
    methods: {
      open() {
        this.step = 1;
        this.$modal.show('terminateServiceModal1');
      },
      openTerminateServiceModal2() {
        this.step = 1;
        this.$modal.hide('terminateServiceModal1')
        this.$refs.terminateServiceModal2.open();
      },
      openTerminateServiceModal3() {
        this.$refs.terminateServiceModal2.close();
        this.$nextTick(()=>{
          this.$refs.terminateServiceModal3.open();
        })
      },
      selectReason(item) {
        this.value.terminate_reason_detail = '';
        this.value.terminate_reason = item.value;
      },
      hideTerminateServiceModal() {
        this.step = 1;
        this.$modal.hide('terminateServiceModal1');
      },
      setPrice(e) {
        this.value.reason_detail = e.target.value;
      },
      clickStep() {
        this.step++;
      },
      saveData(price) {
        let params = this.value;
        params.terminate_service_status = this.selectedServiceStatus;
        params.price = price;
        this.$axios.post('admin/launchpack/service/terminate', params).then(res => {
          this.$refs.terminateServiceModal3.close();
          this.step = 4;
          this.service.terminate_expect_date = this.service.plan.next_date;
          this.$modal.show('terminateServiceModal1');
        })
      },
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .circle
    border 1px solid #cccccc
    width 18px
    height 18px
    border-radius 50%
    background-color white

  .circle-selected
    width 18px
    height 18px
    border 3px solid $primary
    border-radius 50%
    background-color white

  ul
    list-style disc
    padding-left 14px

  .t-content
    padding 0 8px
  .t-title
    font-size 18px
    font-weight 600
    margin-top -16px
    margin-bottom 16px
  .t-subtitle
    font-size 14px
    margin-bottom 8px
  .t-body
    font-size 13px

  .t-button-group
    margin-top 42px
    display flex
    align-items center
    justify-content center
    gap 0 24px

  .t-grid
    display grid
    grid-template-columns 140px 1fr
    margin-top 4px

  .lp-modal-wrapper
    padding 24px
    padding-bottom 32px
    background-color #e9e9e9

  .box-shutdown
    background-color #FFEDE1
    padding 8px 16px
    border-radius 8px
    font-size 12px
    margin-top 20px
    gap 0 12px
  .button-shutdown
    width 106px
    height 32px
    font-size 12px !important
</style>
<style lang="stylus">
  .service-terminate .sweet-modal.bounce
    -webkit-animation-name none
    animation-name none
  .terminate-2
    .sweet-modal.is-alert .sweet-content
      padding 44px 24px 32px 24px
</style>
